<template>
  <mw-dialog size="large_large" :appendToBody="false" :footerButton="footerButton" ref="dialog" :title="title">
    <innerOrg :params="params" ref="org"></innerOrg>
  </mw-dialog>
</template>

<script>
  import {mapGetters} from 'vuex'
  import innerOrg from './org.vue'

  export default {
    components: {
      innerOrg
    },
    props: {
      params: {
        type: Object
      }
    },
    data() {
      return {
        title:$lang(this.params.config.getConfig()?(this.params.config.getConfig().label?this.params.config.getConfig().label:'选择部门及人员'):(this.param.label?this.param.label:'选择部门及人员')),
        footerButton: [{
          label: $lang('确定'),
          func: this.save
        }]
      }
    },

    mounted() {
      setTimeout(() => {
        this.show();
      }, 200)
    },
    computed: {
      ...mapGetters([
        'expUser'
      ]),
      defaultTreeParams() {
        return {rootId: this.expUser.dep.loginUnit.id}
      }
    },
    methods: {

      changed(data) {
        this.refreshTableDefaultParams({departmentId: data.id});
      },

      refreshTableDefaultParams(params) {
        this.defaultParams = params;
      },

      save() {
        let data = this.mwRef('org').getValue();
        /*debugger;
        let data=[];
        dept.forEach(v=>{
          data.push(v)
        })
        if (data.length < 1) {
          this.mwMsg('info', '请选择部门用户！');
          return;
        }*/
        this.params.func(data);
        this.mwRef('dialog').hide();
      },
      show() {
        this.mwRef('dialog').show();
      },
      close() {
        this.mwRef('dialog').hide();
      }

    }
  }
</script>





// WEBPACK FOOTER //
// src/modules/index/components/public-dialog/form/org-select.vue